'use strict';

angular.module('mobile-apps')
	.service('EntryHighlight', ['VARIABLE_EXPRESSIONS', 'GlossaryMain',
		function(VARIABLE_EXPRESSIONS, GlossaryMain) {

			var factory = {};


			// ---------------- HIGHLIGHT FUNCTIONS ----------------
			// The functions which return which terms should be highlighted
			// If they return an object nothing gets highlighted.


			/**
			 * Highlights glossary terms
			 */
			var glossaryHighlightFunction = function(baseText, entryText, displayField, data, isActive, classNameAppend) {

				if (!classNameAppend) {
					classNameAppend = '';
				}

				var allMatches = {};

				if (!data || !data.languages || !data.languages.base || !data.languages.entry) {
					// If we do not know which languages are used skip it because
					// that information is needed for the check
					return [];
				}

				if (data.languages.base === data.languages.entry) {
					baseText = baseText || entryText;
				}

				var baseLanguageValue, checkValue;

				for (var entryId in GlossaryMain.entries) {
					var entryTranslations = GlossaryMain.entries[entryId].translations;
					// Check first if there is really a value set for the base
					// language
					if (entryTranslations.hasOwnProperty(data.languages.base)) {
						baseLanguageValue = entryTranslations[data.languages.base].trim();

						if (baseLanguageValue === '') {
							continue;
						}

						if (baseText.indexOf(baseLanguageValue) !== -1) {

							// The glossary entry value is in the base entry
							if (entryTranslations.hasOwnProperty(data.languages.entry)) {
								// If there is a value in the language defined use it
								checkValue = entryTranslations[data.languages.entry];
							} else {
								// If there is no value for the language use base one
								checkValue = baseLanguageValue;
							}

							// Depending on if the base, source or the entry value
							// gets displayed different terms have to get marked
							var markTerm = checkValue;

							if (displayField === 'base') {
								markTerm = baseLanguageValue;
							} else if (displayField === 'source' && data.languages.hasOwnProperty('source') && entryTranslations.hasOwnProperty(data.languages.source)) {
								markTerm = entryTranslations[data.languages.source];
							}

							if (entryText.indexOf(checkValue) === -1) {
								// If not found, mark it as missing
								allMatches[markTerm] = {
									className: 'highlight-glossary-missing' + classNameAppend
								};
							} else if (isActive === true) {
								// If entry is active, mark also found ones
								allMatches[markTerm] = {
									className: 'highlight-glossary-found' + classNameAppend
								};
							}
						}
					}
				}

				return allMatches;
			};


			/**
			 * Highlights variables
			 */
			var variableHighlightFunction = function(baseText, entryText, displayField, data, isActive, classNameAppend) {
				var text = entryText;
				if (displayField === 'base' || displayField === 'source') {
					text = baseText;
				}

				let allMatches = {};

				VARIABLE_EXPRESSIONS.forEach(function(regex) {
					var matches = text.match(regex);
					if (matches) {
						matches.forEach(function(match) {
							allMatches[match] = {
								className: 'highlight-variable' + (classNameAppend || '')
							};
						});
					}
				});

				return allMatches;
			};


			// Defines all the highlight functions which run by default
			factory.highlightFunctions = {
				glossaryHighlightFunction: glossaryHighlightFunction,
				variableHighlightFunction: variableHighlightFunction
			};


			/**
			 * Runs the given highlight functions and returns the highlighted
			 * text
			 */
			factory.runHighlightFunctions = function(highlightFunctions, baseText, sourceText, entryText, displayField, data, isActive, classNameAppend) {
				let me = this;

				let allMatches = {};

				highlightFunctions.forEach(function(highlightFunction) {
					var matches = highlightFunction(baseText, entryText, displayField, data, isActive, classNameAppend);
					for (let key in matches) {
						allMatches[key] = matches[key];
					}
				});

				let text = entryText;
				if (displayField === 'base') {
					text = baseText;
				} else if (displayField === 'source') {
					text = sourceText;
				}

				let matchTerms = Object.keys(allMatches);
				if (matchTerms.length !== 0) {
					// Make the values unique to not replace the same
					// multiple times
					matchTerms = matchTerms.filter (function (value, index, array) {
						return array.indexOf (value) === index;
					});

					// Sort them by length that we replace the long
					// matches before the shorter one to avoid double
					// replaces.
					matchTerms.sort(function(a, b) {
						return b.length - a.length;
					});

					// Setting a limit of matches to manage, since entries loading was crashing
					// due to an entry that had over 4500 matches, which it not possible.
					// More info in: AL-2674
					if(matchTerms.length <= 50){
						for (let index = 0; index < matchTerms.length; index++) {
							const matchTerm = matchTerms[index];
							
							// Matching all special characters so that we can
							// escape them avoiding posible rendering and console errors 
							let checkMatch = matchTerm.replace(/[^A-Za-z0-9 ]/g, function(letter){ return '\\' + letter; });
							
							let matchData = allMatches[matchTerm];
	
							// Thats not perfect but should be fine for now.
							// Creates a regex out of the match + space or end
							// of string afterwards to not risk to match something
							// twice if two matches start the same.
							text = text.replace(new RegExp(checkMatch, 'g'), '<span class="' + matchData.className + '">' + matchTerm + '</span>');
						}
					} else {
						// Reducing the text of a possible error entry that 
						// could have more text than it should, because if not
						// browser gets slower due to that much html to handle
						// More info: AL-2674
						text = text.slice(0, 450); 
					}
				}

				if (!isActive) {
					// If it is not active we add some special characters to
					// text like line breaks
					text = me.addSpecialCharacters(text);
				}

				return text;
			};


			/**
			 * Runs all the available highlight functions and returns the
			 * highlighted text
			 */
			factory.highlightText = function(baseText, sourceText, entryText, displayField, data, isActive, classNameAppend) {
				var me = this;

				// Get all the functions to run
				var highlightFunctions = Object.keys(me.highlightFunctions).map(
					function(functionName) {
						return me.highlightFunctions[functionName];
					}
				);

				// Run all the highlight functions
				var displayText = me.runHighlightFunctions(highlightFunctions, baseText, sourceText, entryText, displayField, data, isActive, classNameAppend);

				if (!isActive) {
					// If it is not active we add some special characters to
					// text like line breaks
					displayText = me.addSpecialCharacters(displayText);
				}

				return displayText;
			};


			/**
			 * Adds some special characters to text like like line breaks
			 * and tabs
			 * @param text The text to add the special characters to
			 * @returns {*}
			 */
			factory.addSpecialCharacters = function(text) {
				// Add new line character
				text = text.replace(/\n/g, '&crarr;');

				// Add tab character
				text = text.replace(/\t/g, '&rarr;');

				return text;
			};


			return factory;
		}
	]);

